/**
 * Static Route - React Router v7
 *
 * Handles legal / markdown-driven pages:
 *   /condiciones-de-uso, /condiciones-de-uso-reserva, /cookies-otros-partners,
 *   /tramites-compra-venta-coches, /tramites-compra-venta-motos,
 *   /guia-seguridad-compra-venta-coches, /guia-seguridad-compra-venta-motos.
 *
 * The Static component picks its markdown document from `pageName`, which the loader
 * derives from the pathname via `get_page_name_page_use_case`.
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import Context from '@s-ui/react-context'

import {getInitialProps} from './getInitialProps.js'
import StaticComponent from './index.js'

import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const Static = Context.wrapper(StaticComponent)

export async function loader({context, request}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  // Trailing slash is needed for `get_page_name_page_use_case` to resolve the pageName.
  const pathname = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`

  const routeInfo = {
    location: {
      pathname,
      search: url.search
    }
  }

  try {
    const initialProps = await getInitialProps({routeInfo, context})
    return {...initialProps, __RR7__: true}
  } catch (error: unknown) {
    console.error('[RR7] Static loader error:', error)
    throw error
  }
}

export function Component() {
  const data = useLoaderData()
  return <Static {...data} />
}

Component.displayName = 'StaticRoute'
